module.exports = __webpack_public_path__ + "img/Motorcycle.b7abb456.svg";